import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Table,
    Spinner,
    Button
} from 'reactstrap';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { apiURL1 } from '../../config';
import Header from '../../components/Headers/Header';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import './ViewExam.css';
import { FaArrowRight } from 'react-icons/fa';
import ComputeResultTab from './ComputeResult';
import Footer from 'components/Footers/Footer';

const baseURL = apiURL1; // Replace with your actual base URL

function SubjectResult() {
    const token = localStorage.getItem("token");

    const { id } = useParams();
    const navigate = useNavigate();
    const [exam, setExam] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('subjectResult');

    useEffect(() => {
        fetchExam();
    }, [id]);

    const fetchExam = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${baseURL}/superadmin/exams/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the headers
                }
            }); // Replace with your actual API endpoint
            // console.log('url is ', `${baseURL}/superadmin/exams/${id}`, 'reponse is ', response.data.data)
            setExam(response.data.data);
        } catch (error) {
            // console.error('Error fetching exam:', error);
            toast.error('Error fetching exam');
        } finally {
            setLoading(false);
        }
    };

    const generateExamSlip = () => {
        const pdf = new jsPDF();
        pdf.setFontSize(18);
        pdf.text(`Exam Details`, 10, 10);

        pdf.setFontSize(14);
        pdf.text(`Class: ${exam?.class?.className}`, 10, 20);
        pdf.text(`Course: {exam?.course?.courseName}`, 10, 28);
        pdf.text(`Type: {exam?.type?.name}`, 10, 36);
        pdf.text(`Year: {exam?.year}`, 10, 44);
        // pdf.text(`Status: {exam?.status}`, 10, 52);

        const tableData = exam?.examDetails?.map(detail => [
            detail.subject.subjectCode,
            detail.subject.name,
            detail.teacher ? detail.teacher.name : 'N/A',
            dayjs(detail.examDate).format('DD-MM-YYYY'),
        ]);

        pdf.autoTable({
            head: [['Subject Code', 'Subject', 'Staff', 'Date']],
            body: tableData,
            startY: 60,
            styles: {
                fontSize: 10,
                cellPadding: 5,
                overflow: 'linebreak',
                halign: 'center',
                valign: 'middle',
            },
            headStyles: {
                fillColor: [41, 128, 185],
                textColor: 255,
                fontStyle: 'bold',
                halign: 'center',
            },
            alternateRowStyles: {
                fillColor: [220, 220, 220]
            }
        });

        pdf.save(`exam-details-${exam.class.className}-${exam.course.courseName}.pdf`);
    };

    const handlePrint = () => {
        setTimeout(() => {
            window.print();
        }, 500);
    };

    const handleSubjectClick = (subjectId, subjectName, teacherName, type, year) => {
        if (exam && exam.class) {
            navigate(`/admin/add-subject-result/${exam.class._id}/${subjectId}/${id}`, {
                state: {
                    className: exam.class.className,
                    subjectName: subjectName,
                    teacherName: teacherName,
                    type: exam?.type?.name,
                    typeId: exam?.type?._id,
                    year: exam.year
                }
            });
        } else {
            toast.error("Exam or Class details not available.");
        }
    };

    const handleGoBack = () => {
        navigate('/admin/academic-progress-management');
    };

    if (loading) {
        return (
            <>
                <Header />
                <Container>
                    <Row>
                        <Col>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Spinner color="primary" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }

    if (!exam) {
        return (
            <>
                <Header />
                <Container>
                    <Row>
                        <Col>
                            <p>Exam not found.</p>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }

    return (
        <>
            <Header />
            <Container>
                <Row>
                    <Col>
                        <Card>
                            <CardHeader className="print-hidden" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h3>Result for Exam</h3>
                                <div>
                                    <Button
                                        color={activeTab === "subjectResult" ? "info" : "secondary"}
                                        onClick={() => setActiveTab("subjectResult")}
                                        style={{ marginRight: '10px' }}
                                    >
                                        Add Subject Result
                                    </Button>
                                    <Button
                                        color={activeTab === "computeResult" ? "info" : "secondary"}
                                        onClick={() => setActiveTab("computeResult")}
                                    >
                                        View Result
                                    </Button>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {activeTab === 'subjectResult' && (
                                    <>
                                        <div className="exam-info">
                                            <h4>Class: {exam?.class?.className}</h4>
                                            <p>Course: {exam?.course?.courseName}</p>
                                            <p>Type: {exam?.type?.name}</p>
                                            <p>Year: {exam?.year}</p>
                                            {/* <p>Status: {exam?.status === 'draft' ? 'DRAFT' : 'PUBLISHED'}</p> */}
                                        </div>

                                        <Table className="table">
                                            <thead>
                                                <tr style={{ backgroundColor: '#2980b9', color: 'white' }}>
                                                    <th>Subject Code</th>
                                                    <th>Subject</th>
                                                    <th>Staff</th>
                                                    <th>Date</th>
                                                    <th>Result</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {exam?.examDetails?.map((detail, index) => (
                                                    <tr key={detail._id} style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : 'white' }}>
                                                        <td>{detail.subject.subjectCode}</td>
                                                        <td>{detail.subject.name}</td>
                                                        <td>{detail.teacher ? detail.teacher.name : 'N/A'}</td>
                                                        <td>{dayjs(detail.examDate).format('DD-MM-YYYY')}</td>
                                                        <td style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => handleSubjectClick(detail.subject._id, detail.subject.name, detail.teacher ? detail.teacher.name : 'N/A', exam?.type, exam.year)}>
                                                            <FaArrowRight />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </>
                                )}
                                {activeTab === 'computeResult' && (
                                    <ComputeResultTab
                                        classId={exam?.class?._id}
                                        type={exam?.type?.name}
                                        typeId={exam?.type?._id}
                                        year={exam?.year}
                                        examDetails={exam?.examDetails}
                                        uniClassName={exam?.class?.className}
                                    />
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="print-only">
                    <Col>
                        <div className="exam-info">
                            <h4>Class: {exam?.class?.className}</h4>
                            <p>Course: {exam?.course?.courseName}</p>
                            <p>Type: {exam?.type?.name}</p>
                            <p>Year: {exam?.year}</p>
                            {/* <p>Status: {exam?.status}</p> */}
                        </div>
                        <Table className="table">
                            <thead>
                                <tr style={{ backgroundColor: '#2980b9', color: 'white' }}>
                                    <th>Subject Code</th>
                                    <th>Subject</th>
                                    <th>Staff</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {exam?.examDetails?.map((detail, index) => (
                                    <tr key={detail._id} style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : 'white' }}>
                                        <td>{detail.subject.subjectCode}</td>
                                        <td>{detail.subject.name}</td>
                                        <td>{detail.teacher ? detail.teacher.name : 'N/A'}</td>
                                        <td>{dayjs(detail.examDate).format('DD-MM-YYYY')}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Footer />
            </Container>
        </>
    );
}

export default SubjectResult;
